exports.createDigitsFromZero = (r) => (new Array(r)).fill(void 0).map((val, i) => i)

exports.createDigitsFromOne = (r) => (new Array(r)).fill(void 0).map((val, i) => i + 1)
